import styled from "styled-components";
import tw from "twin.macro";
import { COLORS } from "../theme";

const SectionFour = styled.section`
  ${tw`relative flex items-center`}
  z-index: 1;
  min-height: 80vh;
  background: #fff;

  @media (max-width: 767px) {
    min-height: auto;
  }
`;

const SectionFourInner = styled.div`
  ${tw`mx-auto`}
  width: 100%;
  padding: 2rem var(--app-content-gutter) 4rem;
  max-width: 1440px;

  @media (min-width: 1440px) {
    max-width: none;
    padding-left: 330px;
    padding-right: 330px;
  }

  @media (min-width: 1024px) and (max-width: 1439px) {
    padding-left: 120px;
    padding-right: 120px;
  }

  @media (max-width: 767px) {
    position: relative;
    padding-top: 5rem;
    padding-bottom: 4rem;
    padding-left: 20px;
    padding-right: 20px;

    &::before {
      content: "";
      position: absolute;
      left: 38px;
      right: 38px;
      top: 4.25rem;
      height: 360px;
      border: 1px solid ${COLORS.orange};
      border-radius: 14px 14px 0 0;
      pointer-events: none;
      z-index: 0;
    }
  }
`;

const SectionFourHeader = styled.div`
  position: relative;
  z-index: 1;
  max-width: 980px;
  margin: 0 auto;

  @media (max-width: 767px) {
    width: min(100%, 560px);
    padding: 2.65rem 2.15rem 0;
  }
`;

const SectionFourMainText = styled.h3`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.14;
  font-weight: 400;
  color: #4d4b4b;
  text-transform: uppercase;

  strong {
    color: ${COLORS.orange};
    font-weight: 700;
  }

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 1.28;
  }
`;

const SectionFourSideText = styled.p`
  margin: 0.45rem 0 0;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  color: #437672;
  text-transform: uppercase;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    margin-top: 1.75rem;
    font-size: 14px;
    line-height: 1.5;
  }
`;

const SectionFourFrame = styled.div`
  position: relative;
  margin-top: 1.55rem;
  padding: 0 2rem;
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1023px) {
    margin-top: 2.6rem;
    padding: 0;
  }

  @media (max-width: 767px) {
    position: relative;
    z-index: 2;
    margin-top: 3.8rem;
  }

  @media (min-width: 1024px) and (max-width: 1366px) {
    margin-top: 1.7rem;
    padding: 0 1.4rem;
  }
`;

const SectionFourOutline = styled.div`
  position: absolute;
  left: 7rem;
  right: 7rem;
  top: 58px;
  height: 186px;
  border: 1px solid ${COLORS.orange};
  border-radius: 20px;
  z-index: 0;

  @media (max-width: 1023px) {
    display: none;
  }

  @media (min-width: 1024px) and (max-width: 1366px) {
    top: 52px;
  }

  @media (min-width: 1366px) {
    left: 4.5rem;
    right: 4.5rem;
  }
`;

const SectionFourCards = styled.div`
  ${tw`grid gap-8 relative`}
  z-index: 1;

  @media (max-width: 767px) {
    width: min(100%, 620px);
    margin: 0 auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 220px));
    justify-content: center;
    column-gap: 2rem;
    align-items: start;
  }

  @media (min-width: 1024px) and (max-width: 1366px) {
    grid-template-columns: repeat(3, minmax(0, 205px));
    column-gap: 1.4rem;
  }
`;

const SectionFourCard = styled.div`
  ${tw`relative overflow-hidden`}
  z-index: 2;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);

  @media (max-width: 767px) {
    border-radius: 8px;
    box-shadow: none;
  }
`;

const SectionFourImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const SectionFourBottomText = styled.p`
  max-width: 980px;
  margin: 4rem auto 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.14;
  font-weight: 400;
  color: #4d4b4b;
  text-transform: uppercase;
  text-align: center;

  strong {
    color: #437672;
    font-weight: 700;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

export {
  SectionFour,
  SectionFourInner,
  SectionFourHeader,
  SectionFourMainText,
  SectionFourSideText,
  SectionFourBottomText,
  SectionFourFrame,
  SectionFourOutline,
  SectionFourCards,
  SectionFourCard,
  SectionFourImage,
};
